// Templates without a scroll-margin-top on their headings (VPN Mentor) keep the old jump offset.
const DEFAULT_OFFSET = 80;

export default function initTocScrollspy() {
  const tocLinks = Array.from(document.querySelectorAll('.toc a'));
  const targets = tocLinks
    .map(a => document.getElementById(a.getAttribute('href').slice(1)))
    .filter(Boolean);
  if (!targets.length) return;
  const currentEl = document.querySelector('[data-toc-current]');
  const firstId = tocLinks[0].getAttribute('href').slice(1);
  let activeId = null;
  const keepInView = (a) => {
    const list = a.closest('.wc-toc__list');
    if (!list || list.scrollHeight <= list.clientHeight) return;
    const item = a.parentElement;
    list.scrollTop = item.offsetTop - (list.clientHeight - item.offsetHeight) / 2;
  };
  const setActive = (id) => {
    if (id === activeId) return;
    activeId = id;
    tocLinks.forEach(a => {
      const on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('active', on);
      if (on) keepInView(a);
      if (on && currentEl) currentEl.textContent = a.textContent.trim();
    });
  };
  const scrollOffset = (el) => parseFloat(getComputedStyle(el).scrollMarginTop) || DEFAULT_OFFSET;

  // The current section is the last heading scrolled up to where a TOC jump puts it, so the
  // previous section stays active while any of it is still on screen. Headings above the viewport
  // count too, so jumping up to a section activates it. At the page bottom a short last section
  // can never reach that line, so the last heading on screen wins there.
  const update = () => {
    const line = scrollOffset(targets[0]) + 2;
    const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
    let id = firstId;
    targets.forEach(t => {
      const top = t.getBoundingClientRect().top;
      if (top <= line || (atBottom && top < window.innerHeight)) id = t.id;
    });
    setActive(id);
  };

  // After a TOC click the clicked item stays active until the smooth scroll settles, so the
  // headings passed on the way do not flash, and a short last section is not overridden.
  // If the scroll settles away from the jump target (the user scrolled meanwhile), the spy takes over.
  let lockTimer = null;
  let lockTop = 0;
  const lock = () => {
    clearTimeout(lockTimer);
    lockTimer = setTimeout(() => {
      lockTimer = null;
      if (Math.abs(window.scrollY - lockTop) > 2) update();
    }, 150);
  };
  let ticking = false;
  const onScroll = () => {
    if (lockTimer) {
      lock();
      return;
    }
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      // a frame queued before a TOC click must not override the clicked item
      if (!lockTimer) update();
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();

  tocLinks.forEach(a => a.addEventListener('click', (e) => {
    const id = a.getAttribute('href').slice(1);
    const el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    const top = el.getBoundingClientRect().top + window.scrollY - scrollOffset(el);
    const maxTop = document.documentElement.scrollHeight - window.innerHeight;
    lockTop = Math.max(0, Math.min(top, maxTop));
    setActive(id);
    lock();
    window.scrollTo({ top, behavior: 'smooth' });
    history.replaceState(null, '', '#' + id);
  }));
}
